import DeskUsage from './DeskUsage';
import Route from './route';

export default {
  RenderProp: DeskUsage,
  mainRoute: Route,
};
